<template>
  <div class="card modal-card is-min-width-700">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="center">
        <div class="columns is-gapless">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
            {{ getTitle() }}
            </h1>
          </div>
        </div>
      </div>
      <div class="card-content">
        <liaisons-tarif :produit="produit" :liaisons-tarif="liaisonsTarif">
        </liaisons-tarif>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="addIndcf()">
              {{ $t('ajoutSalonDcf.liaisonTarif.addInCart') }}
            </a>
          </div>
        </b-field>
      </footer>
      </div>
    </div>
  </div>
</template>

<script>
import liaisonsTarif
  from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/liaisonsTarif';
import { CATEGORIE_SALON, CATEGORIE_SPONSORING } from '@/configuration/catalogue/produitConf';

export default {
  name: 'displayLiaisonTarifOfProduit',
  props: {
    liaisonsTarif: {
      type: Array,
      required: true,
    },
    produit: {
      type: Object,
      required: true,
    },
  },
  components: {
    liaisonsTarif,
  },
  methods: {
    addIndcf() {
      const liaisonsSelectedId = this.liaisonsTarif.filter((el) => el.selected).map((el) => el.id);
      this.$emit('addIndcf', {
        liaisonsId: liaisonsSelectedId,
        produitId: this.produit.id,
      });
    },
    getTitle() {
      switch (this.produit?.supportCommercial?.categorieVente) {
        case CATEGORIE_SALON:
        case CATEGORIE_SPONSORING:
          return this.$t('ajoutSalonDcf.liaisonTarif.titlePrestation');
        default:
          return this.$t('ajoutSalonDcf.liaisonTarif.title');
      }
    },
  },
};
</script>

<style scoped>

</style>
